import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventWithRelationsDto, ResponseDto } from "@mimber/schema"
import { eventsKeys } from "../events.utils"

interface DeleteEventImageOptions extends Omit<
  UseMutationOptions<ResponseDto<EventWithRelationsDto>, Error, void>,
  "mutationFn"
> {}

export const useDeleteEventImage = (
  eventUuid: string,
  options: DeleteEventImageOptions = {}
): UseMutationResult<ResponseDto<EventWithRelationsDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useDeleteEventImage")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.delete<ResponseDto<EventWithRelationsDto>>(
        `events/${eventUuid}/image`
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findAll(),
      })
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findOne(eventUuid),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
